import React from "react";

interface Props {
  options: Array<{ label: string; value: string }>;
  value: string;
  onChange: (value: string) => void;
  defaultValue?: string;
  className?: string;
}

const Select = ({
  options,
  value,
  onChange,
  defaultValue = options[0]?.value,
  className = "",
}: Props) => {
  const isFiltered = value !== defaultValue;

  return (
    <div className="relative inline-flex items-center">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`focus:border-blue-500 outline-none border-2 rounded-2xl py-2 pl-4 pr-10 block ${
          isFiltered ? `border-blue-500 text-blue-500` : ``
        } ${className}`}
      >
        {options.map((o, i) => (
          <option key={i} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
